import { useCallback } from 'react';
import { useToggle, useLatest } from 'react-use';
import { get } from 'lodash';
import { useSyncDeviceMutation } from 'apis/cm';

function useSectorKPIs(device, options) {
  const deviceRef = useLatest(device);
  const [open, toggleOpen] = useToggle(false);
  const mutation = useSyncDeviceMutation(options);
  const { mutate, isLoading } = mutation;
  const operationalState = get(device, 'rfPath.service-info.operational-state', 'disabled');
  const errors = validate({ operationalState });
  const handleRefresh = useCallback(() => {
    const { donorId } = deviceRef.current;
    mutate({ deviceId: donorId });
  }, [deviceRef, mutate]);

  return {
    mutation,
    trigger: { disabled: errors.length > 0, onClick: toggleOpen },
    tooltip: { title: errors.length > 0 ? errors[0].message : undefined },
    dialog: { open, device, refreshing: isLoading, onRefresh: handleRefresh, onClose: toggleOpen }
  };
}

export default useSectorKPIs;

function validate({ operationalState }) {
  const errors = [];

  if (operationalState === 'disabled') {
    errors.push({
      type: 'device',
      message: 'Operational state must be enabled to view Sector KPIs'
    });
  }

  return errors;
}
